import { ApiService } from '../Services/APIService';
import { ENDPOINTS } from '../Utils/APIConstants';
import { StorageUtils } from "../Utils/StorageUtils";  

export const BillingService = {
  
    // Create subscription (recurring payments)
    createSubscription: async (data) => {
      const token = StorageUtils.getUserData()?.token;
      ApiService.setAuthToken(token);
      return ApiService.post(ENDPOINTS.SUBSCRIPTION_CREATE, data);
    },

    // Create Stripe Checkout Session (for hosted checkout flow)
    createCheckoutSession: async (data) => {
      const token = StorageUtils.getUserData()?.token;
      ApiService.setAuthToken(token);
      return ApiService.post(ENDPOINTS.CHECKOUT_SESSION, data);
    },

    // Create payment intent (one-time payments)
    createPaymentIntent: async (intentData) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;

    // Set the token in ApiService
    ApiService.setAuthToken(token);

    // Make the API call
    return ApiService.post(ENDPOINTS.STIPE_PAYMENT_INTENT, intentData);
  },

  fetchPaymentPlans: async (planData) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;

    // Set the token in ApiService
    ApiService.setAuthToken(token);

    // Make the API call
    return ApiService.get(ENDPOINTS.PAYMENT_PLANS, planData);
  },

  // Create Stripe Checkout Session for subscription
  createCheckoutSession: async (data) => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.post(ENDPOINTS.CHECKOUT_SESSION, data);
  },

  // Create Stripe billing portal session for subscription management
  createBillingPortalSession: async () => {
    const token = StorageUtils.getUserData()?.token;
    ApiService.setAuthToken(token);
    return ApiService.post(ENDPOINTS.BILLING_PORTAL, {});
  }

};
